import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Package"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 22.5H4.5C3.67157 22.5 3 21.8284 3 21V12C3 11.1716 3.67157 10.5 4.5 10.5H6.75V12H4.5V21H19.5V12H17.25V10.5H19.5C20.3284 10.5 21 11.1716 21 12V21C21 21.8284 20.3284 22.5 19.5 22.5ZM12.75 9.1275L15.4425 6.4425L16.5 7.5L12 12L7.5 7.5L8.5575 6.4425L11.25 9.1275V1.5H12.75V9.1275ZM14.25 16.5V15H9.75V16.5H14.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Package.vue"]]);
